import $ from 'static/script/libs/jquery';
export default $.ajax;
